import moment from 'moment';

export const isInMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mini/i.test(window.navigator.userAgent);

export const prefixInteger = (num: number): string => {
    return !+num || num > 9 ? `${+num || ''}` : `0${+num}`;
};

export const monthDay = (num: number): string => prefixInteger(num + 1);

export function getCookie(key: string) {
    const re = new RegExp(`.*${key}=([^;]+).*`);
    if (re.test(document.cookie)) {
        return decodeURIComponent(document.cookie.replace(re, '$1'));
    }
    return '';
}

interface ICookieOptions {
    expires?: Date;
    path?: string;
    domain?: string;
}

export function setCookie(key: string, value: string | number, options?: ICookieOptions) {
    if (!key) return;
    document.cookie = [
        encodeURIComponent(key),
        '=',
        encodeURIComponent(value),
        options?.expires ? `; expires=${options.expires.toUTCString()}` : '',
        options?.path ? `; path=${options.path}` : '',
        options?.domain ? `; domain=${options.domain}` : '',
    ].join('');
}

export function doLike(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, code: string) {
    const cookieKey = `_baike_like_${code}`;
    const liked = !!getCookie(cookieKey);
    if (liked) {
        event.preventDefault();
        event.stopPropagation();
        return;
    }
    setCookie(cookieKey, Date.now(), { expires: new Date(Date.now() + 3600 * 1000 * 24 * 30) });
}

export const isValidDate = (date: string[]) => {
    const now = moment();
    return now.isBetween(date[0], date[1]);
};
